module.exports = __webpack_public_path__ + "img/Perfil_EnvironmentHome2d.1fce2dde.png";